export default __webpack_public_path__ + "static/srushtika-neelakantam-423b189964e82a7717b8e72ac51fdf08.jpg";